<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">

    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">STRATEGIES</li>
            </ol>
        </nav>
    </div>
    <div class="ms-auto" *ngIf="admin == 'true'">
        <div class="btn-group">
        </div>
    </div>
</div>

<div class="card">
    <div class="card-body">
        <div class="d-flex">
            <div class="me-auto p-2" *ngIf="admin == 'true'">
                <div class="form-group">
                    <select class="form-select shadow-none" [(ngModel)]="selUserId" (change)="onSelUser()">
                        <option *ngFor="let user of users" [value]="user._id"> {{ user.full_name }}</option>
                    </select>
                </div>
            </div>
            <div class="ms-auto p-2">
                <button class="btn btn-primary btn-sm m-1 ps-0 shadow-none" (click)="loadDetails()">
                    <span class="btn-label">
                        <i class="bi bi-arrow-repeat"></i>
                        Refresh
                    </span>
                </button>
                <button class="btn btn-primary btn-sm ps-0 shadow-none" (click)="openAddModal()">
                    <span class="btn-label">
                        <i class="bi bi-plus-lg"></i>
                        Add Strategy
                    </span>
                </button>
            </div>
        </div>
        <div class="table-responsive mt-3">
            <table class="table align-middle">
                <thead class="table-secondary">
                    <tr>
                        <th scope="col">STRATEGY NAME</th>
                        <th scope="col" class="text-center">SYMBOL</th>
                        <th scope="col" class="text-center">BROKER</th>
                        <th scope="col" class="text-center">ENTRY/EXIT</th>
                        <th scope="col" class="text-center">ACTIONS</th>
                        <th scope="col" class="text-center">STATUS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let us of userStrategies" ng-if="userStrategies.length > 0">
                        <td>
                            <div class="row">
                                <div class="col-8">
                                    <div *ngIf="!us.dname_edit.mode" class="text-truncate">
                                        <!-- <div class="tooltip-arrow"></div> -->
                                        <a id="strategyName" data-bs-toggle="tooltip" [attr.data-bs-title]="us.strategy_name">{{ us.strategy_name }}</a>
                                    </div>
                                    <div *ngIf="us.dname_edit.mode">
                                        <input type="text" class="form-control" [(ngModel)]="us.dname_edit.text">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div *ngIf="!us.dname_edit.mode">
                                        <i class="bi bi-pencil" (click)="editDname(us)"></i>
                                    </div>
                                    <div *ngIf="us.dname_edit.mode">
                                        <div class="table-actions d-flex align-items-center gap-3 fs-6">
                                            <i class="bi bi-check-circle text-success" (click)="updateDname(us)"></i>
                                            <i class="bi bi-x-circle text-danger" (click)="cancelDname(us)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="text-center">{{ us.symbol.trading_symbol }}</td>
                        <td class="text-center">{{ us.broker }}</td>
                        <td class="text-center">{{ us.entry_exit_time }}</td>
                        <!-- <td class="col-md-1">{{ us.exit_time }}</td> -->
                        <td class="text-center">
                            <div class="table-actions d-flex justify-content-center align-items-center gap-2 fs-6">
                                <i class="bi bi-play-fill play-pause-icon" [ngClass]="us.strategy_state" (click)="startStop(us)"></i>
                                <!-- <i class="bi bi-arrow-clockwise" [ngClass]="us.restart_state" (click)="restart(us)"></i> -->
                                <i class="bi bi-front text-dark" (click)="showCopyModal(us)"></i>
                                <i class="bi bi-pencil-square" [ngClass]="us.edit_state" (click)="edit(us)"></i>
                                <i class="bi bi-trash trash-icon" [ngClass]="us.delete_state" (click)="onDelete(us)"></i>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="form-check form-switch form-check-reverse d-flex justify-content-center">
                                <input class="form-check-input" type="checkbox" id="listSwitch" [checked]="us.enabled" (click)="onStatusClick($event, us)">
                                <label class="form-check-label" for="listSwitch"></label>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="userStrategies.length == 0">
                        <td colspan="6" class="col-md-12 text-center">No Strategies Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<strategy-details-modal></strategy-details-modal>

<div id="deleteConfirmationModal" class="modal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ALERT</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Are you sure want to delete this strategy?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="deleteStrategy(0)">Close</button>
          <button type="button" class="btn btn-danger" (click)="deleteStrategy(1)">Delete</button>
        </div>
      </div>
    </div>
</div>

<div id="enableConfirmationModal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ALERT</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="updateStrategyStatus(0, enableParams.us)"></button>
        </div>
        <div class="modal-body">
          <p>Are you sure want to {{ enableParams.type }} this strategy?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="updateStrategyStatus(0, enableParams.us)">Close</button>
          <button type="button" class="btn" [ngClass]="enableParams.action_class" (click)="updateStrategyStatus(1, enableParams.us)">{{ enableParams.action }}</button>
        </div>
      </div>
    </div>
</div>
